function TextAlignLeft({ size }: { size: number }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
			<path
				d="M3.33398 5H16.6673M3.33398 10H11.6673M3.33398 15H15.0007"
				stroke="#5B5B5B"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default TextAlignLeft;
